module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_burger.3aa9edfd.png";